import React from 'react'
import { useSelector } from 'react-redux'
import { IonCol, IonGrid, IonLabel, IonRow } from '@ionic/react'
import { getCookieSelector } from '../../cookie/selectors'
import { useTranslation } from 'react-i18next'
import { getReleaseVersion } from '../../../utilities/version.util'

const Version: React.FC = (): JSX.Element => {
  const cookie = useSelector(getCookieSelector)
  const { t } = useTranslation()

  const getVersionLabel = (): string => {
    if (process.env.NODE_ENV === 'development') {
      return `${t('login.version.versionRunningLocally')}`
    }
    return `${getReleaseVersion(t('login.version.version'), t('login.version.build'))}`
  }

  const getBranchLabel = (): string => `${t('login.version.branch')} ${cookie}`

  return (
    <IonGrid>
      <IonRow>
        <IonCol class='ion-text-center'>
          <IonLabel color='white'>{getVersionLabel()}</IonLabel>
        </IonCol>
      </IonRow>

      {cookie && (
        <IonRow>
          <IonCol class='ion-text-center'>
            <IonLabel color='white'>{getBranchLabel()}</IonLabel>
          </IonCol>
        </IonRow>
      )}
    </IonGrid>
  )
}

export default Version
